import React, { ReactNode } from "react";
import { PortalContentContainer } from "./PortalContentContainer/PortalContentContainer";
import { OverlaySubjectContainer } from "./OverlaySubjectContainer/OverlaySubjectContainer";
import { DrAceContainer } from "./DrAceContainer/DrAceContainer";
import { TimerContainer } from "./TimerContainer/TimerContainer";

interface IProps {
    children: ReactNode;
}

export function ContextContainer({children}: IProps) {
    return (
        <>
            <PortalContentContainer>
                <OverlaySubjectContainer>
                    <DrAceContainer>
                        <TimerContainer>
                            {children}
                        </TimerContainer>
                    </DrAceContainer>
                </OverlaySubjectContainer>
            </PortalContentContainer>
        </>
    )
}
